import axiosService from "services/axios.service";

export const loginAs = async (userId: string): Promise<any> => {
  const response = await axiosService.post(`v1/admin/users/${userId}/login-as`, {});
  return response?.data?.data;
};

